<div class="flex h-full w-full flex-wrap align-items-center background-login">
  <div class="flex w-12 md:w-6 lg:w-4 col-offset-0 md:col-offset-3 lg:col-offset-4 px-3 md:px-0 lg:px-0">
    <p-card class="w-full">
      <router-outlet></router-outlet>
    </p-card>
  </div>
</div>
